<div class="toasts">
    @for (toast of toasts; track toast) {
<div [class.error-toast]="toast.toastType === toastType.Error" [class.info-toast]="toast.toastType === toastType.Info" [class.success-toast]="toast.toastType === toastType.Success" (click)="closeToast(toast)">
        @if (toast.toastType === toastType.Error) {
<span class="ups-icon ups-icon-exclamation" style="grid-area: icon;"></span>
}
        @if (toast.toastType === toastType.Info) {
<span class="ups-icon ups-icon-information" style="grid-area: icon;"></span>
}
        @if (toast.toastType === toastType.Success) {
<span class="ups-icon ups-icon-check" style="grid-area: icon;"></span>
}
        <div class="message">{{toast.text}}</div>
        @if (!toast.hideDismissIcon) {
<span role="button" class="ups-icon ups-icon-x" style="grid-area: close;"></span>
}
    </div>
}
</div>